import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3f46bfe8&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46bfe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f46bfe8')) {
      api.createRecord('3f46bfe8', component.options)
    } else {
      api.reload('3f46bfe8', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=3f46bfe8&scoped=true", function () {
      api.rerender('3f46bfe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting-phone/common/components/startFive/main.vue"
export default component.exports